import { render, staticRenderFns } from "./AlertsAmphibien.vue?vue&type=template&id=680234cd&"
import script from "./AlertsAmphibien.vue?vue&type=script&lang=js&"
export * from "./AlertsAmphibien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports